// extracted by mini-css-extract-plugin
export default {"search-input":"style_search-input__8aH1G__WHx6O","is-popup":"style_is-popup__L0973__WHx6O"};